import React from "react";
import { Box, IconButton } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useTranslation } from "react-i18next";
import { TooltipWrapper } from "../tooltipWrapper/TooltipWrapper";

function DeleteAction({ onClick, disabled }) {
  const { t } = useTranslation();

  return (
    <Box>
      <TooltipWrapper title={t("tooltips.deleteOrder")}>
        <span>
          <IconButton aria-label="delete" color="primary" onClick={onClick} disabled={disabled}>
            <DeleteIcon />
          </IconButton>
        </span>
      </TooltipWrapper>
    </Box>
  );
}

export default DeleteAction;
